export { default } from './ResetPasswordModal';
